import React, { useEffect, useRef, useState } from "react";
import { appConfigs, arrayToSentence, formatFileSize } from "../../_helpers";
import axios from "axios";
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Refresh from '@material-ui/icons/Refresh';
import Close from '@material-ui/icons/Close';
import { shallowEqual, useSelector } from "react-redux";

let file = undefined;

export function FileUploader({ title = '', description = '', type, enabled = false, alert, uploadingStatus, limitSize = 1024, limitExtensions = [], uploaded, error = false }) {
    const el = useRef();
    const [uploadingFile, setUploadingFileStatus] = useState(false);
    const [retry, setRetryStatus] = useState(false);
    const [progress, setProgress] = useState(0);
    const { authToken } = useSelector(
        (state) => ({
            authToken: state.auth.authToken,
        }),
        shallowEqual
    );

    useEffect(() => {
        file = undefined;
    }, []);

    const accept = () => {
        if (limitExtensions.length >= 1) {
            const _formatted = limitExtensions.map(str => "." + str.toLowerCase());
            return _formatted.join(', ');
        } else return '';
    }
    const handleUploadingFileStatus = (status) => {
        setUploadingFileStatus(status);
        uploadingStatus(status);
    }
    const handleFileChange = (e) => {
        alert(null);
        const _file = e.target.files[0];
        if (_file !== undefined) {
            file = _file;
            uploadFile();
        }
    }
    const resetUpload = () => {
        alert(null);
        file = undefined;
        setRetryStatus(false);
        el.current.value = '';
    }
    const [activeClass, setActiveClass] = useState('');
    const handleSetActiveClass = (active) => setActiveClass(active ? 'is-active' : '');
    const isValid = () => {
        const extRegex = /(?:\.([^.]+))?$/;
        const ext = extRegex.exec(file?.name)[1];
        if (file?.size > limitSize) {
            resetUpload();
            alert({ type: 'error', msg: `Selected ${type} is too large. It should be less than ${formatFileSize(limitSize)}, please check and try again.` });
            return false;
        } else if (limitExtensions.length > 0) {
            const exts = limitExtensions.map(str => str.toLowerCase());
            if (!exts.includes(ext)) {
                resetUpload();
                alert({ type: 'error', msg: `Selected ${type} is not allowed. Allowed ${(exts.length === 1) ? 'extension is' : 'extensions are'} <strong>${arrayToSentence(exts)}</strong>. Please check and try again.` });
                return false;
            }
            return true;
        }
        return true;
    }

    const uploadFile = () => {
        setRetryStatus(false);
        if (!isValid()) return;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('api_key', appConfigs.auth_key);
        formData.append('jwt', authToken);
        alert(null);
        handleUploadingFileStatus(true);
        uploadingStatus(true);
        axios.post(appConfigs.api_url + 'upload-file', formData, {
            onUploadProgress: (ProgressEvent) => {
                let progress = Math.round(ProgressEvent.loaded / ProgressEvent.total * 100);
                setProgress(progress);
            }
        }).then(res => {
            if (res.data.response_code === 1) {
                // alert({ type: 'success', msg: `The ${type} was uploaded successfully.` });
                resetUpload();
                uploaded(res.data.file);
            } else {
                alert({ type: 'error', msg: res.data.description || 'A critical error occurred while uploading the file, please try again.' });
                setRetryStatus(true);
            };
            handleUploadingFileStatus(false);
        }).catch(err => {
            alert({ type: 'error', msg: err || 'A critical error occurred, please try again.' });
            handleUploadingFileStatus(false);
            setRetryStatus(true);
        });
    }

    return (
        <>
            {(title !== '') && <p style={{ marginBottom: '4px', color: error ? '#f018a6' : 'var(--mn-text-50)', fontSize: '1rem' }}>{title}</p>}
            <div className={"file-drop-area " + activeClass + (error ? ' is-error' : '')} onDragOver={() => handleSetActiveClass(true)} onDragLeave={() => handleSetActiveClass(false)} onDrop={() => handleSetActiveClass(false)}>
                <span className="fake-btn">Choose {type}</span>
                <span className="file-msg">{(!file) ? 'or drag and drop ' + type + ' here' : file?.name}</span>
                <input className="file-input" type="file" ref={el} onChange={handleFileChange} disabled={enabled} title="" accept={accept()} />
                <div className={"file-drop-area-progress " + ((uploadingFile || retry) ? '' : 'd-none')}>
                    {!retry && <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <CircularProgress color="secondary" variant="determinate" value={progress} />
                        <Box
                            style={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography variant="caption" component="div" color="secondary">
                                {`${progress}%`}
                            </Typography>
                        </Box>
                    </Box>}
                    {retry && <Box style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', }}>
                        <IconButton color="secondary" onClick={() => uploadFile()}><Refresh /></IconButton>
                        <IconButton color="default" onClick={() => resetUpload()}><Close /></IconButton>
                    </Box>}
                </div>
            </div>
            {(description !== '') && <p style={{ marginTop: '10px', marginBottom: '12px', color: error ? '#f018a6' : 'var(--mn-text-50)', fontSize: '0.75rem', lineHeight: '1' }}>{description}</p>}
        </>
    );
}
